// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-timeline-container {
  width: 100%;
  padding: 10px 0;
  -webkit-user-select: none;
          user-select: none;
}

.video-timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #666;
  font-family: monospace;
}

.time-current {
  font-weight: bold;
  color: #333;
}

.time-total {
  color: #999;
}

.video-timeline-track {
  position: relative;
  height: 40px;
  background: #f0f0f0;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  overflow: hidden;
}

.timeline-progress-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8f8;
}

.timeline-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);
  transition: width 0.1s ease;
  opacity: 0.3;
}

.timeline-playhead {
  position: absolute;
  top: -2px;
  width: 2px;
  height: calc(100% + 4px);
  background: #2196F3;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 0 3px rgba(33, 150, 243, 0.5);
}

.timeline-playhead::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  width: 10px;
  height: 10px;
  background: #2196F3;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.timeline-marker {
  position: absolute;
  top: 0;
  height: 100%;
  border-radius: 2px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  pointer-events: none;
  z-index: 5;
}

.timeline-marker:hover {
  opacity: 1;
}

.timeline-marker.clip {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  border: 1px solid #E65100;
  min-width: 8px;
}

.timeline-marker.frame {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  border: 1px solid #4A148C;
  width: 3px !important;
  min-width: 3px;
}

/* Hover effects */
.video-timeline-track:hover .timeline-progress-fill {
  opacity: 0.5;
}

.video-timeline-track:active .timeline-progress-fill {
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .video-timeline-track {
    height: 35px;
  }
  
  .video-timeline-header {
    font-size: 11px;
  }
  
  .timeline-marker.frame {
    width: 2px !important;
    min-width: 2px;
  }
}

/* Animation for smooth seeking */
.timeline-progress-fill {
  will-change: width;
}

.timeline-playhead {
  will-change: left;
}

/* Focus styles for accessibility */
.video-timeline-track:focus {
  outline: 2px solid #2196F3;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideoTimeline.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".video-timeline-container {\n  width: 100%;\n  padding: 10px 0;\n  user-select: none;\n}\n\n.video-timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #666;\n  font-family: monospace;\n}\n\n.time-current {\n  font-weight: bold;\n  color: #333;\n}\n\n.time-total {\n  color: #999;\n}\n\n.video-timeline-track {\n  position: relative;\n  height: 40px;\n  background: #f0f0f0;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  overflow: hidden;\n}\n\n.timeline-progress-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #f8f8f8;\n}\n\n.timeline-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);\n  transition: width 0.1s ease;\n  opacity: 0.3;\n}\n\n.timeline-playhead {\n  position: absolute;\n  top: -2px;\n  width: 2px;\n  height: calc(100% + 4px);\n  background: #2196F3;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 0 3px rgba(33, 150, 243, 0.5);\n}\n\n.timeline-playhead::before {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  width: 10px;\n  height: 10px;\n  background: #2196F3;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.timeline-marker {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  border-radius: 2px;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n  z-index: 5;\n}\n\n.timeline-marker:hover {\n  opacity: 1;\n}\n\n.timeline-marker.clip {\n  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);\n  border: 1px solid #E65100;\n  min-width: 8px;\n}\n\n.timeline-marker.frame {\n  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);\n  border: 1px solid #4A148C;\n  width: 3px !important;\n  min-width: 3px;\n}\n\n/* Hover effects */\n.video-timeline-track:hover .timeline-progress-fill {\n  opacity: 0.5;\n}\n\n.video-timeline-track:active .timeline-progress-fill {\n  opacity: 0.6;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .video-timeline-track {\n    height: 35px;\n  }\n  \n  .video-timeline-header {\n    font-size: 11px;\n  }\n  \n  .timeline-marker.frame {\n    width: 2px !important;\n    min-width: 2px;\n  }\n}\n\n/* Animation for smooth seeking */\n.timeline-progress-fill {\n  will-change: width;\n}\n\n.timeline-playhead {\n  will-change: left;\n}\n\n/* Focus styles for accessibility */\n.video-timeline-track:focus {\n  outline: 2px solid #2196F3;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
